export const messages = {

  alerts: {
    subscribe: {
      cashbacker_no_action: "Congratulations!! You are already a member of my customer club and have an account at Cashbacker.se."
    }
  },
  errors: {
    "UNIQUENESS_VIOLATION": "Duplicate",
    "EMAIL_TAKEN": "Email taken"
  },

  loginScreen: {
    emailField: "Email",
    passwordField: "Password",
    loginButton: "Log in"
  },
  navigation: {
    logout: "Log out"
  },

  resources: {
    users: {
      name: "Users"
    },
    admins: {
      name: "Administrators",
      titleCreate: "Create administrator",
      titleEdit: "Administrator",
      inputs: {
        email: "e-mail",
        password: "Password",
        repeatPassword: "Repeat the password",
        phoneNumber: "Phone number",
      },
      fields: {
        email: "e-mail",
        phoneNumber: "Phone number",
        createdAt: "created at",
        updatedAt: "updated at",
      },
      validation: {
        email: "The email is required",
        phone: "The phone number format is incorrect",
        phoneRequired: "The phone number is required",
        password: "The password is required",
        repeatPassword: "Retyping the password is required",
        matchPasswords: "Passwords do not match",
      }
    },
    storeOwners: {
      name: "Store owners",
      titleEdit: "Store owner",
      titleCreate: "Create store owner",
      search: "Search store owner by first name",
      filter_last_name: "Search store owner  by last name",
      fields: {
        storeOwner: "store owner",
        email: "e-mail",
        companyName: "company name",
        companyAddress: "company address",
        active: "active"
      },
      inputs: {
        firstName: "First name",
        lastName: "Last name",
        email: "E-mail",
        password: "Password",
        repeatPassword: "Repeat the password",
        companyName: "Company name",
        companyNumber: "Company number",
        city: "City",
        postNumber: "Post number",
        active: "active"
      },
      validation: {
        firstName: "The first name is required",
        lastName: "The last name is required",
        email: "The email is required",
        password: "The password is required",
        repeatPassword: "Retyping the password is required",
        matchPasswords: "Passwords do not match",
        companyName: "The company name is required",
        companyNumber: "The company number is required",
        city: "The city is required",
        postNumber: "The post number name is required",
        validateZipCode: "Must be a valid Zip Code",
        validateCompanyNumber:
          "Must be a valid Company number (with or without () and /)"
      }
    },
    regions: {
      name: "Regions",
      titleEdit: "Region",
      titleCreate: "Create region",
      fields: {
        name: "Region name"
      },
      inputs: {
        name: "Region name"
      }
    },
    stores: {
      name: "Stores",
      titleEdit: "Store",
      titleCreate: "Create store",
      titleTab1: "General information",
      titleTab2: "Web Information",
      titleTab3: "Assigned promotions",
      titleTab4: "Extra",
      search: "Search store",
      fields: {
        storeName: "Store name",
        sender: "SMS sender",
        storeOwner: "Store owner",
        activePromos: "Assigned Active Promotions",
        email: "E-mail",
        phone: "phone",
        deviceSerialNumber: "Device Serial Number",
        active: "Active",
        region: "Region",
      },
      inputs: {
        storeOwner: "Store owner",
        storeName: "Store name",
        region: "Region",
        sender: "SMS sender",
        phoneNumber: "Phone number",
        email: "E-mail",
        deviceSerialNumber: "Device Serial Number",
        active: "Active",
        giftcard: "Gift card",
        hasQuestionnaire: "Show questionnaire",
        promos: "Promotions",
        storeUrlText: "Store URL text",
        shortUrl: "Link",
        customerNumber: "Customer number",
        headline: "Store headline",
        about: "About the store",
        workingHours: {
          header: "Opening hours",
          regular: {
            days: "mon-fri",
            start: "opening time",
            end: "closing time"
          },
          other: {
            saturday: "sat",
            sunday: "sun",
            start: "opening time",
            end: "closing time"
          },
          holiday_differ: "Different working hours during holiday"
        },
        facebookPage: "Facebook page URL (https://www.facebook.com/store)",
        address: "Address",
        lng: "Longitude",
        lat: "Latitude",
        placeSearch: "Search",
        loading: "Loading...",
        marketingPartner: {
          william_hill: {
            name: "William Hill",
            pid: "PID"
          },
          mrGreen: {
            name: "Mr Green",
            marketingSourceId: "Marketing Source ID"
          },
          cashbacker: {
            name: "Cashbacker"
          },
          storemarket: {
            name: "Storemarket"
          },
          betfair: {
            name: "Betfair",
            pid: "PID"
          }
        }
      },
      validation: {
        storeOwner: "The store owner selection is required",
        storeName: "The store name is required",
        sender: "SMS sender is required",
        senderASCII: "Character not supported",
        senderCharacter: "Must be at least one character",
        email: "The email is required",
        phone: "The phone number is required",
        requiredStoreUrl: "Store URL required",
        storeUrlPattern: "Wrong pattern",
        customerNumberFormat: "Wrong customer number format",
        headline: "Store headline is required",
        about: "About the store is required",
        workingHours: {
          regular: {
            start: "Opening hours - start is required",
            end: "Opening hours - end is required"
          },
          other: {
            start: "Opening hours - start is required",
            end: "Opening hours - end is required"
          }
        },
        address: "Address is required"
      }
    },
    marketingPartners: {
      name: "Marketing partners",
      titleEdit: "Marketing partner",
      titleTabFeatures: "Features",
      titleTabWebStyle: "Web style",
      fields: {
        name: "Name",
        features: {
          integration: "Integration",
          signup_sms: "Signup sms",
          signup_url: "Signup url",
          affiliate_links: "Affiliate links",
          gift_card: "Gift cards",
        },
        createdAt: "created at"
      },
      inputs: {
        webOfferStyle: {
          logo: "Logo image (%{dimensions})",
          backgroundColor: "Background color",
          textColor: "Text color"
        }
      },
      validation: {
        requiredBackgroundColor: "Background color is required!",
        requiredTextColor: "Text color is required!"
      }
    },
    customers: {
      name: "Customers",
      titleEdit: "Customer",
      search: "Search customer by first name",
      filter_last_name: "Search customer by last name",
      fields: {
        storeName: "store name",
        customer: "customer",
        email: "e-mail",
        phone: "phone",
        createdAt: "created at",
        updatedAt: "updated at",
        active: "active"
      },
      inputs: {
        storeName: "Store name",
        firstName: "First name",
        lastName: "Last name",
        email: "E-mail",
        phoneNumber: "Phone number",
        active: "Active"
      },
      validation: {
        storeName: "The store selection is required",
        firstName: "The first name is required",
        lastName: "The last name is required",
        contact: "The email or the phone number is required",
        phone: "The phone number is invalid"
      }
    },
    suppressions: {
      name: "Suppressions",
      titleEdit: "Customer",
      search: "Search customer by first name",
      filter_last_name: "Search customer by last name",
      fields: {
        storeName: "store name",
        customer: "customer",
        email: "e-mail",
        phone: "phone",
        createdAt: "created at",
        updatedAt: "updated at",
        active: "active"
      },
      inputs: {
        storeName: "Store name",
        firstName: "First name",
        lastName: "Last name",
        email: "E-mail",
        phoneNumber: "Phone number",
        active: "Active",
        uploadEmailList: "Upload e-mail list",
        uploadPhoneList: "Upload phone list",
        uploadButton: "Upload"
      },
      validation: {
        storeName: "The store selection is required",
        firstName: "The first name is required",
        lastName: "The last name is required",
        contact: "The email or the phone number is required",
        phone: "The phone number is invalid"
      }
    },
    gametips: {
      name: "Game tips",
      titleEdit: "Game tip",
      titleCreate: "Create game tip",
      search: "Search title",
      fields: {
        title: "title",
        author: "author",
        date: "date",
        published: "published"
      },
      inputs: {
        articleImage: "Article image",
        title: "Title",
        author: "Author",
        date: "Date",
        published: "Publish?"
      },
      validation: {
        images: "The image is required",
        title: "The title is required",
        author: "The author is required",
        date: "The date is required",
        content: "The content is required"
      }
    },
    virtualSlips: {
      name: "Virtual slips",
      titleEdit: "Virtual slip",
      titleCreate: "Create virtual slip",
      search: "Search store",
      fields: {
        storeName: "Store name",
        expert: "Expert",
        betType: "Game type",
        startDate: "Start date",
        sharegameSize: "Number of shares",
        shares: "Shares",
        currency: "kr",
        shareCost: "Price per share",
        totalCost: "Total price",
        closingTime: "Bet closing time",
        link: "Link",
        created_at: "Created at"
      },
      inputs: {
        storeName: "Store name",
        expert: "Expert",
        betType: "Game type",
        startDate: "Start date",
        sharegameSize: "Number of shares",
        shares: "Shares",
        shareCost: "Price per share",
        totalCost: "Total price",
        betClosingTime: "Last pole",
        closingDate: "Bet closing time",
        closingTime: "Time (hours, minutes)",
        date: "Datum",
        hours: "Timmar"
      },
      validation: {
        requiredBetType: "The bet type is required",
        requiredStoreName: "The store name is required",
        requiredExpert: "The expert is required",
        requiredStartDate: "The start date is required",
        requiredClosingTime: "The closing time is required",
        requiredShareCost: "The price per share is required",
        requiredTotalCost: "The total price is required",
        requiredValidNumberFormat: "Invalid number format",
        requiredAgentCharge: "The agent charge is required",
        requiredShareNumber: "The number of shares is required",
        requiredAtLestOne: "At least one bet pair is required",
        requiredField: "required",
        requiredBINLength: "must be 3 characters long"
      }
    },
    promos: {
      name: "Promos",
      titleEdit: "Promo",
      titleCreate: "Create promo",
      titleTab1: "General data",
      titleTab2: "Assigned stores",
      titleTab4: "Extra",
      search: "Search promo",
      selectToSeeExtraTab: "Select marketing partners to view this tab",
      fields: {
        promoName: "Promo name",
        validFrom: "Valid from",
        validTo: "Valid to",
        industry: "Industry",
        marketingPartner: "Marketing partner",
        assignedStoresCount: "Nr. of assigned stores",
        active: "Active",
        promoText: "Promo text",
        title: "Title",
        description: "Text",
        tosText: "Terms of service",
        externalLink: "External link",
        backgroundImage: "Background image",
        image: "Promo image (%{dimensions})",
        smallImage: "Small promo image (%{dimensions})",
        displayLocation: "This promotion wil be shown:"
      },
      inputs: {
        promoName: "Promo name",
        validFrom: "Valid from",
        validTo: "Valid to",
        industry: "Industry",
        marketingPartner: "Marketing partner",
        category: {
          label: "Category",
          choices: {
            sports: 'Sports',
            casino: 'Casino',
          }
        },
        activate: "Activate",
        giftcard: "Gift card",
        deactivate: "Deactivate",
        promoText: "Promo text",
        tosText: "Terms of service",
        description: "Description",
        externalLink: "External link",
        localPageText: "Offer text",
        voucherCode: "Voucher Code",
        voucherCodeGenerate: "Generate",
        image: "Promo image (%{dimensions})",
        smallImage: "Small promo image (%{dimensions})",
        stores: "Stores",
        displayLocation: {
          label: "Display this promotion:",
          inputBefore: "before data input",
          inputAfter: "after data input"
        },
        displayOnTablet: "Display on tablet",
        displayOnWeb: "Display on Web",
        smsFromDefault: "Betmarket",
        smsTextDefault: `Hej, välkommen till {{.Store.Name}}  kundklubb.\n\nUnder fotbolls-VM kommer du få de bästa matchtipsen och analyserna samt mina personliga andelsspel direkt i mobilen.\n\nVi hörs den 14 juni när VM börjar.\nHa det bra.`,
        marketingPartnerTab: {
          william_hill: {
            name: "William Hill",
            bid: "BID"
          },
          mrGreen: {
            name: "Mr Green",
            lpid: "LPID",
            bid: "BID"
          },
          cashbacker: {
            name: "Cashbacker",
            campaign_id: "Campaign ID"
          },
          storemarket: {
            name: "Storemarket"
          },
          betfair: {
            name: "Betfair",
            bid: "BID"
          }
        }
      },
      validation: {
        requiredPromoName: "The promotion name is required",
        requiredValidFrom: "The valid from date is required",
        requiredValidTo: "The valid to date is required",
        requiredIndustry: "The industry is required",
        requiredMarketingPartnerName: "The marketing partner name is required",
        requiredDescription: "The description is required",
        requiredImage: "The image is required",
        requiredImageDimensions: {
          large: "Image dimensions must be %{dimensions}.",
          small: "Image dimensions must be %{dimensions}.",
          current: "(Dimensions of current image: "
        },
        requiredTosText: "The terms of service are required",
        requiredVoucherCodeLength: "must be 10 characters long",
        requiredVoucherCodeUppercase: "must be all uppercase",
        requiredBothIDFields: "both ID fields must be either empty or filled"
      }
    },
    activation: {
      name: "In-store activation",
      description: "Ask customer if he/she would like to have the latest campaign and be a part of your customer club.",
      fields: {
        phone: "Phone number",
        email: "Email",
        check: "Check customer",
        add: "Add new customer",
        update: "Register",
        reset: "Add new +",
        addCampaign: "SKICKA KAMPANJ TILL DIN KUND"
      },
      titleCreate: "Create new",
      customerAdded: "Customer successfully added.",
      customerAddError: "Kundanpassningen misslyckades",
      customerNotFound: "Customer not found, please add email information to create a new customer.",
      campaignAdded: "Campaign successfully sent!",
      campaignAddFailed: "Campaign sending error",
      customerUpdated: "Customer updated",
      customerUpdateError: "Customer update failed",
      steps: {
        "title": "This is how it works",
        "1":"Add customer mobile phone no.",
        "2":"Add customer e-mail",
        "3":"Select campaign",
        "4":"Send campaign",
        "5":"Your customer will shortly receive a SMS with campaign and T&C. When customer click on attached link (in SMS) he/her will be redirected to selected campaign.",
      }
    },
    messageTemplates: {
      name: "Message templates",
      titleEdit: "Message template",
      fields: {
        name: "name"
      },
      inputs: {
        name: "Name",
        description: "Description",
        smsContent: "SMS content"
      }
    },
    storeMessages: {
      name: "Store messages",
      titleEdit: "Store message",
      deletedStore: "Deleted store",
      fields: {
        storeName: "store name",
        smsFrom: "SMS from",
        emailFrom: "E-mail from",
        emailSubject: "E-mail subject",
        sentAt: "Sent at",
        emailPlainText: "E-mail plain text",
        emailHtmlText: "E-mail HTML text",
        smsText: "SMS text",
        dialogBox: {
          confirmMessage: "Are you sure?",
          warningMessage: "This cannot be undone.",
          confirmButton: "I am sure!",
          cancelButton: "Cancel"
        }
      },
      inputs: {
        emailPlainText: "E-post oformatterad text",
        emailHtmlText: "E-post HTML text",
        smsText: "SMS text",
        emailFrom: "E-post från",
        emailSubject: "E-post ämne",
        contentPlainText: "Innehåll oformatterad text",
        contentHtml: "Innehåll HTML",
        smsFrom: "SMS från"
      },
      validation: {
        smsFrom: "Message sender is required",
        smsText: "Message text is required",
        emailFrom: "E-mail sender is required",
        emailText: "E-mail text is required",
        emailSubject: "E-mail subject is required",
        plainText: "Plain text is required",
        emailHtml: "E-mail HTML is required"
      }
    },
    welcomeMessage: {
      name: "Welcome Message",
      fields: {
        emailPlainText: "Email plain text",
        emailHtmlText: "Email HTML text",
        smsText: "SMS text",
        emailFrom: "E-mail from",
        emailSubject: "E-mail subject",
        contentPlainText: "Content plain text",
        contentHtml: "Content HTML",
        smsFrom: "SMS from"
      },
      inputs: {
        emailPlainText: "Email plain text",
        emailHtmlText: "Email HTML text",
        smsText: "SMS text",
        emailFrom: "E-mail from",
        emailSubject: "E-mail subject",
        contentPlainText: "Content plain text",
        contentHtml: "Content HTML",
        smsFrom: "SMS from"
      },
      validation: {
        email: "The email is required",
        name: "The name is required",
        smsText: "SMS is required"
      }
    },
    devices: {
      name: "Devices",
      titleEdit: "Device",
      reportsTable: "Reports",
      search: "Search store name",
      fields: {
        storeName: "Store name",
        deviceSerialNumber: "Device serial number",
        lastReport: "Last report",
        timestamp: "Created at",
        uptime: "Up time",
        unknownUptime: "Unknown up time",
        wifiConnectionName: "WiFi Connection name",
        application_version: "Application version"
      },
      inputs: {
        storeName: "Store name"
      }
    },
    reports: {
      mainReportsPageTitle: "Report",
      customerReportsTitle: "Customer Analytics Report",
      giftCardsReportsTitle: "Gift Cards Analytics Report",
      customerPhonesReportsTitle: "Customer Phones Report",
      customerEmailsReportsTitle: "Customer Emails Report",
      cashbackerCampaignRegistrationsReportsTitle: "Cashbacker Report",     
      name: "Reports",
      titleEdit: "Reports",
      reportsTable: "Reports",
      // fields: {
      //   storeName: "Butiksnamn",
      //   deviceSerialNumber: "Enhets serienummer",
      //   lastReport: "Senaste rapporten",
      //   timestamp: "Skapad vid",
      //   uptime: "Upp tid",
      //   wifiConnectionName: "WiFi-anslutningsnamn"
      // },
      dateFrom: "Date from",
      dateTo: "Date to",
      exportAction: "Export",
      chooseBothDates: "Choose date from both filters"
    },
    giftCards: {
      name: "Gift Cards",
      create: "Add new",
      editGiftCard: "Gift Card",
      createGiftCard: "Create Gift Card",
      customer: "Customer",
      activateButton: "Activate Gift Card",
      saveButton: "Save",
      customerCreateError: "Customer creation failed",
      checkCustomerButton: "Check Customer",
      customerNotChecked: "You haven't checked customer!",
      promosLabel: "Promos",
      valuesLabel: "Values"
    },
    noPermissiom: {
      text: "Sorry, only ADMIN can see this"
    },
    interpolations: {
      instructions: `Templates support interpolation of values, so they get dynamically inserted based on store, customer and
      promotion. Note that the interpolation must be used exactly - inside double curly braces {{ }} and
      spaces, with correct WordCasing and starting with a dot .`,
      supported: "Supported interpolation:"
    }
  },
  // error messages
  ERROR_READING_IMAGE_DATA:
    "Unable to OCR the image, please try again - error 2001",
  ERROR_CONSTRUCTING_OCR_REQUEST:
    "Unable to OCR the image, please try again - error 2002",
  ERROR_CONTACTING_OCR_SERVICE:
    "Unable to OCR the image, please try again - error 2003",
  ERROR_READING_OCR_RESPONSE:
    "Unable to OCR the image, please try again - error 2004",
  ERROR_PROCESSING_OCR_RESPONSE:
    "Unable to OCR the image, please try again - error 2005",
  ERROR_STORING_SLIP_RECORD: "Error saving virtual slip - error 2006",
  ERROR_CONSTRUCTING_OCR_RESPONSE: "Oops, something went wrong - error 2007",
  SLIP_NOT_FOUND: "Virtualslip not found - error 2008",
  ERROR_FETCHING_SLIP_RECORD: "Virtualslip unreadable - error 2009",
  ERROR_CONSTRUCTING_SLIP_RESPONSE: "Oops, something went wrong - error 2010",
  ERROR_READING_SLIP_DATA: "Error saving virtual slip - error 2011",
  ERROR_PROCESSING_SLIP_DATA: "Error saving virtual slip - error 2012",
  SLIP_UPDATE_NOT_FOUND: "Virtualslip not found - error 2013",
  ERROR_PROCESSING_SLIP_RECORD: "Error saving virtual slip - error 2014",
  ERROR_UPDATING_SLIP_RECORD: "Error saving virtual slip - error 2015",
  ERROR_CONSTRUCTING_UPDATE_RESPONSE: "Oops, something went wrong - error 2016",
  ERROR_GENERATING_NOTIFICATIONS: "Error generating notifications - error 2017",
  ERROR_SENDING_NOTIFICATIONS: "Error sending notifications - error 2018",
  ERROR_DECODING_SLIP_UUID: "Virtualslip not found - error 2019",
  ERROR_CONVERTING_SLIP_UUID: "Virtualslip not found - error 2020"
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n/en.js